export default "__VITE_ASSET__qSDs0XsK__"